import React from 'react';

function UserTableRowSkeleton() {
  return (
    <tr className="border-b border-border">
      {/* Avatar */}
      <td className="px-3 py-2">
        <div className="h-8 w-8 rounded-full bg-muted animate-pulse" />
      </td>

      {/* Last Name */}
      <td className="px-3 py-2">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* First Name */}
      <td className="px-3 py-2">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Email */}
      <td className="px-3 py-2">
        <div className="h-4 w-40 bg-muted rounded animate-pulse" />
      </td>

      {/* Department */}
      <td className="px-3 py-2">
        <div className="h-4 w-16 bg-muted rounded animate-pulse" />
      </td>

      {/* Level */}
      <td className="px-3 py-2">
        <div className="h-4 w-10 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* Goal */}
      <td className="px-3 py-2">
        <div className="h-4 w-10 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* Admin */}
      <td className="px-3 py-2">
        <div className="h-4 w-4 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* English */}
      <td className="px-3 py-2">
        <div className="h-4 w-8 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* Created */}
      <td className="px-3 py-2">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Last Login */}
      <td className="px-3 py-2">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Actions */}
      <td className="px-3 py-2">
        <div className="h-8 w-8 bg-muted rounded animate-pulse ml-auto" />
      </td>
    </tr>
  );
}

export default UserTableRowSkeleton;
